const keyPrefix = 'FASIT_SUMMA_SHOW_DRAFTS_';

// The choice belongs to one user, so a colleague in the same browser does not inherit it.
export function readShowDrafts(userId?: string) {
  if (!userId) {
    return false;
  }

  try {
    return localStorage.getItem(`${keyPrefix}${userId}`) === 'true';
  } catch {
    return false;
  }
}

export function storeShowDrafts(userId: string | undefined, showDrafts: boolean) {
  if (!userId) {
    return;
  }

  try {
    localStorage.setItem(`${keyPrefix}${userId}`, String(showDrafts));
  } catch {
    // Without storage the choice simply falls back to off next time.
  }
}
